<template>
  <div class="Breadcrumb-Container">
    <span v-for="(crumb, index) in crumbs" :key="crumb.value" @click="onClick(crumb)">
      <span :class="classes(crumb)">{{ crumb.label }}</span>
      <span v-if="index < crumbs.length - 1">></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ContentBreadcrumb',
  props: {
    current: {
      type: String,
      required: false
    },
    crumbs: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    classes(crumb) {
      const classes = ['Crumb']

      if (crumb.value === this.current) {
        classes.push('Current')
      }

      if (crumb.routing) {
        classes.push('Link')
      }

      return classes
    },
    onClick(crumb) {
      if (!crumb.routing) return

      this.$router.push(crumb.routing)
    }
  }
}
</script>

<style lang="scss" scoped>
.Breadcrumb-Container {
  .Crumb {
    margin: 0 5px;

    &.Current {
      font-weight: bold;
    }

    &.Link {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
